module.exports = __webpack_public_path__ + "media/promo/velle/images/green_subs-4ebcd0e28f04e2c1256373cad2824738.png";